import React from "react"
import { Formik } from "formik"
import Yup from "yup"
import FormWrapper from "components/Form/FormFields/FormWrapper"
import FormTitle from "components/Form/FormFields/FormTitle"
import TextInput from "components/Form/FormFields/TextInput"
import SubmitButton from "components/Form/FormFields/SubmitButton"
import ErrorMessage from "components/Form/FormFields/ErrorMessage"
import glamorous from "glamorous"
import style from "utils/style"

class StaffNewForm extends React.Component {
  componentWillReceiveProps(newProps) {
    if (this.props.isSubmitting && newProps.hasErrors) {
      this.props.setSubmitting(false)
    }
  }

  render() {
    const {
      values,
      touched,
      errors,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      formError,
    } = this.props

    return (
      <Container>
        <FormTitle>Create Staff Account</FormTitle>

        {this.props.hasErrors && (
          <ErrorMessage>Account creation failed. {formError}</ErrorMessage>
        )}

        <FormWrapper onSubmit={handleSubmit}>
          <TextInput
            id="email"
            label="Email"
            placeholder="Enter your email"
            type="text"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && errors.email}
            inline
          />

          <TextInput
            id="password"
            label="Password"
            placeholder="Enter your password"
            type="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.password && errors.password}
            inline
          />

          <TextInput
            id="password_confirmation"
            label="Confirmation"
            placeholder="Confirm password"
            type="password"
            value={values.password_confirmation}
            onChange={handleChange}
            onBlur={handleBlur}
            error={
              touched.password_confirmation && errors.password_confirmation
            }
            inline
          />

          <TextInput
            id="first_name"
            label="First Name"
            placeholder="Enter your first name"
            type="text"
            value={values.first_name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.first_name && errors.first_name}
            inline
          />

          <TextInput
            id="last_name"
            label="Last Name"
            placeholder="Enter your last name"
            type="text"
            value={values.last_name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.last_name && errors.last_name}
            inline
          />

          <SubmitButton type="submit" isSubmitting={isSubmitting}>
            Create Account
          </SubmitButton>
        </FormWrapper>
      </Container>
    )
  }
}

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required("email is required")
    .email("must be a valid email address"),
  password: Yup.string()
    .required("password is required")
    .min(6, "too short")
    .max(128, "too long"),
  password_confirmation: Yup.string()
    .required("password confirmation is required")
    .min(6, "too short")
    .max(128, "too long")
    .test("match", "must match password field", function(password) {
      return password === this.options.parent.password
    }),
})

const StaffNewFormik = Formik({
  mapPropsToValues: () => ({
    email: "",
    password: "",
    password_confirmation: "",
    first_name: "",
    last_name: "",
  }),
  validationSchema,
  handleSubmit: (values, bag) => bag.props.handleSubmit(values, bag),
  displayName: "StaffNewForm",
})

export default StaffNewFormik(StaffNewForm)

const Container = glamorous.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  border: `1px solid ${style.colors.mintGreen}`,
  margin: "3rem auto",
  padding: "3rem",
  width: "40rem",
  [style.size.mobile]: {
    width: "100%",
  },
})



// WEBPACK FOOTER //
// ./src/components/Form/StaffNewForm/index.js